<app-auth-card-header>{{ 'Register.Title' | translate }}</app-auth-card-header>

<form [formGroup]="registerForm" (ngSubmit)="register()">
  <fieldset>
    <!-- First Name -->
    <div class="form-group">
      <kj-input
        [formGroup]="registerForm"
        controlName="firstname"
        name="firstname"
        iconName="perm_identity"
        placeholder="{{ 'Register.FirstName' | translate }}"
      ></kj-input>
    </div>

    <!-- Last Name -->
    <div class="form-group">
      <kj-input
        [formGroup]="registerForm"
        controlName="lastname"
        name="lastName"
        iconName="perm_identity"
        placeholder="{{ 'Register.LastName' | translate }}"
      ></kj-input>
    </div>

    <!-- Email -->
    <div class="form-group">
      <kj-input
        [formGroup]="registerForm"
        controlName="email"
        name="email"
        iconName="email"
        placeholder="{{ 'Register.Email' | translate }}"
      ></kj-input>
    </div>

    <!-- Password-->
    <div>
      <mat-form-field style="width: 100%" class="password-field" [color]="passwordComponentWithValidation.color">
        <mat-pass-toggle-visibility #toggleVisbility matSuffix></mat-pass-toggle-visibility>
        <input
          matInput
          [formGroup]="registerForm"
          [formControl]="password"
          controlName="password"
          name="password"
          [type]="toggleVisbility.type"
          #passwordWithValidation
          required
          placeholder="{{ 'Register.Password' | translate }}"
        />
        <mat-hint align="end" aria-live="polite">
          {{ passwordWithValidation.value.length }}
        </mat-hint>
        <mat-error *ngIf="password.hasError('required')" translate="Register.PasswordValidation.Required"> </mat-error>
        <mat-error *ngIf="password.hasError('pattern')" translate="Register.PasswordValidation.Invalid"> </mat-error>
      </mat-form-field>
      <mat-password-strength
        class="green"
        #passwordComponentWithValidation
        [password]="passwordWithValidation.value"
        [min]="8"
        [enableLengthRule]="true"
        [enableUpperCaseLetterRule]="true"
        [enableLowerCaseLetterRule]="true"
        [enableDigitRule]="true"
        [enableSpecialCharRule]="true"
      >
      </mat-password-strength>
      <mat-password-strength-info
        [passwordComponent]="passwordComponentWithValidation"
        [lowerCaseCriteriaMsg]="'Register.PasswordValidation.PasswordRequiresLower' | translate"
        [upperCaseCriteriaMsg]="'Register.PasswordValidation.PasswordRequiresUpper' | translate"
        [digitsCriteriaMsg]="'Register.PasswordValidation.PasswordRequiresDigit' | translate"
        [specialCharsCriteriaMsg]="'Register.PasswordValidation.PasswordRequiresNonAlphanumeric' | translate"
        [minCharsCriteriaMsg]="'Register.PasswordValidation.PasswordTooShort' | translate"
        [passwordComponent]="passwordComponent"
      >
        >
      </mat-password-strength-info>
    </div>

    <!--Confirmed Password-->
    <div>
      <mat-form-field style="width: 100%">
        <input
          matInput
          [formGroup]="registerForm"
          [formControl]="confirmPassword"
          controlName="confirmPassword"
          type="password"
          required
          appConfirmEqualValidator="password"
          placeholder="{{ 'Register.ConfirmPassword' | translate }}"
        />
        <mat-error kj-error [control]="registerForm.get('confirmPassword')"></mat-error>
      </mat-form-field>
    </div>

    <!-- Links to Term and Privacy Policy -->
    <p id="registration-info" class="text-small no-margin">
      <mat-checkbox formControlName="isAgreedToTOS"></mat-checkbox>
      {{ 'Register.Terms.Prefix' | translate }}
      <span class="link" (click)="commonDialogService.showTerms()" translate="Register.Terms.TermsLink"></span>
      {{ 'Register.Terms.Middle' | translate }}
      <span class="link" (click)="commonDialogService.showPrivacy()" translate="Register.Terms.PoliciesLink"></span>
    </p>

    <div class="divider divider-md"></div>

    <button
      mat-raised-button
      color="primary"
      class="float-right"
      role="button"
      type="submit"
      [disabled]="registerForm.invalid"
    >
      {{ 'Register.Button' | translate }}
    </button>
  </fieldset>
</form>

<app-auth-card-footer class="w-100 d-block">
  <a [routerLink]="['/login']">{{ 'Register.FooterText' | translate }}</a>
</app-auth-card-footer>
